import axios from "axios";
import { Response } from "@/shared/models/Response";

export class ChatAssistantService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_CHAT_API}`;
  }

  async getActiveSessions(): Promise<Response<any>> {
    const serviceURL = `${this.baseUrl}/ai-chat/sessions/active`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async searchPatients(
    document: string
  ): Promise<{ id: string; document: string; name: string }> {
    const serviceURL = `${process.env.VUE_APP_CHAT_API}/ai-chat/patients`;
    const response = await axios.get(serviceURL, {
      params: { document }
    });
    return response.data;
  }
}
